export enum SiteReportUtilitySteps {
  Overview = "Overview",
  Success = "Success",
  Error = "Error",
}
